// extracted by mini-css-extract-plugin
module.exports = {"titleWrap":"SectionTitle-module--titleWrap--HBqg1","colorBox":"SectionTitle-module--colorBox--2aS1V","title":"SectionTitle-module--title--2Bio-"};